<template>
<v-main class="pa-3 pb-4">
  <TabelaFuncionarios
   v-bind:lista-funcionarios-ativos="listaFuncionariosAtivos"
   v-bind:lista-funcionarios-desativos="listaFuncionariosDesativos"
   v-bind:descricao-funcionario="'Atendentes'"
   v-bind:tipo-funcionario="'1'"
   v-on:alterar-dados-funcionario="alterarDadosFuncionario"
   v-on:ativar-funcionario="ativarFuncionario"
   v-on:desativar-funcionario="desativarFuncionario"
  >
  </TabelaFuncionarios>

 <v-layout style="height: 90px; position: relative" right bottom >
    <v-btn  id="mybutton" top-of="footer" right fab dark color="teal darken-4" @click=""  :to="{path:'/cadastrarAtendenteUnidade'}">
          <v-icon  dark>add</v-icon>
    </v-btn>
  </v-layout>
</v-main>

</template>

<script>
// import TabelaFuncionarios from '../TabelaFuncionarios'
import Cookies from 'js-cookie'
import TabelaFuncionarios from './../../../assets/components/TabelaFuncionarios'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'listaAdministrador',
  components: {
    TabelaFuncionarios
  },
  data () {
    return {
      page: 1,
      tipo: 3,
      isEditing: true,
      listaFuncionarios: [],
      listaFuncionariosAtivos: [],
      listaFuncionariosDesativos: [],
      user: null,
      items: [
        { username: 'Elvis', idUnidade: '1' },
        { username: 'Cassio', idUnidade: '3' },
        { username: 'Leandro', idUnidade: '2' },
        { username: 'Ana', idUnidade: '15' },
        { username: 'Ricardo', idUnidade: '31' },
        { username: 'Cleison', idUnidade: '22' }
      ]
    }
  },

  mounted () {
    console.log('em mounted adm...')
    this.user = this.$store.getters.usuario
    // console.log(this.user);
    this.retornarFuncionarios()
  },
  methods: {

    alterarDadosFuncionario (item) {
      console.log('em alterar dados..')
      this.$router.push({ name: 'alterarDadosAtendente', params: { item: item } })
    },

    retornarFuncionarios () {
      console.log('em retornar Administradores...')
      administradorUnidadeService.administradorUnidade
        .retornarFuncionarios(this.tipo)
        .then(rsp => {
          console.log('rsp oi:')
          console.log(rsp.data)
          this.listaFuncionarios = rsp.data
          this.listaFuncionarios.forEach(funcionario => {
            if (funcionario.ativo) {
              this.listaFuncionariosAtivos.push(funcionario)
            } else { this.listaFuncionariosDesativos.push(funcionario) }
          })
          // console.log(this.listaChamadas);
          // this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    ativarFuncionario (item) {
      const index = this.listaFuncionariosDesativos.indexOf(item)
      if (confirm('Deseja ativar esse Recepcionista?')) {
        // this.items.splice(index, 1)
        administradorUnidadeService.administradorUnidade
          .ativarFuncionario(item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosDesativos.splice(index, 1)
              this.listaFuncionariosAtivos.push(item)
            }
          })
          .catch(err => {
          // handle your error here
            console.log(err)
          })
      }
    },

    desativarFuncionario (item) {
      const index = this.listaFuncionariosAtivos.indexOf(item)
      if (confirm('Deseja desativar esse Recepcionista?')) {
        // this.items.splice(index, 1)
        administradorUnidadeService.administradorUnidade
          .desativarFuncionario(item.username)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == true) {
              this.listaFuncionariosAtivos.splice(index, 1)
              this.listaFuncionariosDesativos.push(item)
            }
          })
          .catch(err => {
          // handle your error here
            console.log(err)
          })
      } else {}
    }

  },
  created () {
    console.log('created...')
  }
}
</script>

<style  scoped>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }

  .feedback {
  background-color : #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
</style>
